import { Divider } from "@mui/material";

import ContextMenuSubgroup from "./ContextMenuSubgroup.jsx";

const ContextMenuGroup = ({ subgroups }) => {
	return (
		<div>
			{subgroups.map((subgroup, index) => {
				if (subgroup?.isVisible === false) {
					return <></>;
				} else {
					return <ContextMenuSubgroup key={index} {...subgroup} />;
				}
			})}
			<Divider />
		</div>
	);
};

export default ContextMenuGroup;
